import React from 'react';
import { IconProps } from '.';

const SvgUndo = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M8.11 5.014 4.52 8.511h12.155c3.157 0 5.75 2.497 5.75 5.62 0 3.122-2.593 5.619-5.75 5.619h-6.083v-1.5h6.083c2.366 0 4.25-1.863 4.25-4.12 0-2.256-1.884-4.12-4.25-4.12H4.52l3.59 3.498-1.046 1.074L1.6 9.261l5.464-5.322L8.11 5.014Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgUndo;
